export interface TravelAddressConstructor {
  id: number
  name: string
  addressLineOne: string
  city: Nullable<string>
  stateProvince: Nullable<string>
  country: Nullable<string>
  postalCode: string
}

// Value object: `id`/`postalCode` are retained solely because the destination
// PUT payload echoes them back — not used for lifecycle management.
export class TravelAddress {
  readonly id: number
  readonly name: string
  readonly addressLineOne: string
  readonly city: Nullable<string>
  readonly stateProvince: Nullable<string>
  readonly country: Nullable<string>
  readonly postalCode: string

  constructor(data: TravelAddressConstructor) {
    this.id = data.id
    this.name = data.name
    this.addressLineOne = data.addressLineOne
    this.city = data.city
    this.stateProvince = data.stateProvince
    this.country = data.country
    this.postalCode = data.postalCode
  }

  // Itinerary tables render the street line; fall back to the place name
  get displayLabel(): string {
    return this.addressLineOne || this.name
  }
}
